import { useCallback } from 'react';
import { useWaUserStore } from '../store/WaUserStore';
import useWaUserRepo from '../repository/WaUserRepo';

function useWaUsersService() {
  const { setAvailableWorkers: setAvailableUsers, setUsers } = useWaUserStore();
  const {
    getUsersByLocationRequest,
    getUsersByNameLdapPhoneNoRequest,
    getCurrentUserReservations,
  } = useWaUserRepo();

  const getUsers = useCallback(
    async (centerLat: number, centerLon: number, searchRange: number) => {
      try {
        const users = await getUsersByLocationRequest({
          centerLat,
          centerLon,
          searchRange,
        });
        setAvailableUsers(users);
      } catch (error) {
        console.log('Failed to get users by location', error);
        setAvailableUsers([]);
      }
    },
    [getUsersByLocationRequest, setAvailableUsers]
  );

  const getUsersByNameLdapPhoneNo = useCallback(
    (name?: string, ldapId?: string, telephoneNumber?: string) => {
      const params = {
        ...(name !== undefined && { name }),
        ...(ldapId !== undefined && { ldapId }),
        ...(telephoneNumber !== undefined && { telephoneNumber }),
      };

      getUsersByNameLdapPhoneNoRequest(params).then((users) => setUsers(users));
    },
    [getUsersByNameLdapPhoneNoRequest, setUsers]
  );

  const fetchCurrentUserReservations = useCallback(
    async (disasterId: string) => {
      const params = { disasterId };
      try {
        return await getCurrentUserReservations(params);
      } catch (error) {
        console.log('Failed to get user reservations', error);
        return [];
      }
    },
    [getCurrentUserReservations]
  );

  return {
    getUsers,
    getUsersByNameLdapPhoneNo,
    fetchCurrentUserReservations,
  };
}

export default useWaUsersService;
